// extracted by mini-css-extract-plugin
export default {"home":"Home_home__Iy41P","overlay":"Home_overlay__RonVB","text":"Home_text__zy214","ctaButton":"Home_ctaButton__72oi7"};